<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body">
        <b-table :items="dashboardsList" :fields="fields">
          <template slot="name" slot-scope="data">
            <router-link :to="{name: 'Dashboard', params: {id: data.item.id}, query: {name: data.value}}"> {{ data.value }} </router-link>
          </template>
          <template v-if="currentUser.isDigital" slot="widgets" slot-scope="data">
            {{ data.item.widgets }}
          </template>
          <template v-if="currentUser.isDigital" slot="access_level" slot-scope="data">
            {{ data.item.access_level }}
          </template>
          <template slot="actions" slot-scope="data" v-if="dashboardControlsVisible(data.item.dashboard)">
            <b-button type="button" variant="primary" class="action-btn"  @click="$eventBus.$emit('editDashboardModal', data.item.dashboard)" v-b-popover.hover.top="'Edit'">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </b-button>
            &nbsp;
            <b-button type="button" variant="primary" class="action-btn"  @click="$eventBus.$emit('copyDashboardModal', data.item.dashboard)" v-b-popover.hover.top="'Copy'">
              <i class="fa fa-copy" aria-hidden="true"></i>
            </b-button>
            &nbsp;
            <b-button v-if="currentUser.isAdmin || currentUser.id === data.item.dashboard.owner_id" type="button" variant="danger" class="action-btn" @click="showDeleteModal(data.item.id)" v-b-popover.hover.top="'Delete'">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </b-button>
          </template>
          <template slot="default" slot-scope="data">
            <label class="switch switch-pill switch-primary">
              <input type="checkbox" class="switch-input" v-bind:checked="parseInt(currentUser.defaultDashboardId, 10) === parseInt(data.item.id, 10)" v-on:change="checkedDefault(data.item.dashboard)">
              <span class="switch-slider"></span>
            </label>
          </template>
        </b-table>
        <router-view />
      </div>
    </div>

    <dashboard-modal />
    <b-modal title="Delete dashboard" class="modal-danger" v-model="deleteModal" @ok="deleteDashboard" ok-variant="danger">
      Are you sure?
    </b-modal>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import { Switch as cSwitch } from '@coreui/vue'
import DashboardModal from '@/views/modals/DashboardModal'
import { mapGetters, mapActions } from 'vuex'
import { dashboardMixins } from '@/shared/DashboardMixins'

export default {
  name: 'Dashboards',
  mixins: [dashboardMixins],
  components: {
    Callout,
    cSwitch,
    DashboardModal
  },

  data () {
    return {
      deleteModal: false,
      dashboardsList: []
    }
  },

  computed: {
    ...mapGetters([
      'dashboards',
      'currentUser'
    ]),
    fields () {
      var fields = [
        {key: 'name', sortable: true}, {key: 'default'}
      ]
      if (this.currentUser.isDigital) {
        fields.push({key: 'widgets', sortable: true}, {key: 'access_level', sortable: true}, {key: 'actions'})
      }
      return fields
    }

  },

  watch: {
    dashboards: function () {
      this.formatDashboards()
    }
  },

  created () {
    if (this.currentUser){
      this.getDashboards()
    } else {
      this.$router.push('/clients')
    }
  },

  methods: {
    formatDashboards () {
      this.dashboardsList = []
      this.dashboards.forEach(function(dashboard){
        this.dashboardsList.push({
          id: dashboard.id,
          name: dashboard.attributes.name,
          widgets: dashboard.relationships.widgets.data.length,
          access_level: dashboard.attributes.access_level,
          dashboard: dashboard
        })
      }.bind(this))
    },

    showDeleteModal (dashboard_id) {
      this.deleteModal = true
      this.currentDashboardId = dashboard_id
    },

    deleteDashboard () {
      this.deleteModal = false
      this.$http.delete('/dashboards/' + this.currentDashboardId)
        .then(function(){
          this.dashboards.forEach(function(dashboard, index){
            if (dashboard.id === this.currentDashboardId){
              this.dashboards.splice(index, 1)
              this.currentDashboardId = null
              return true
            }
          }.bind(this))
        }.bind(this))
        .catch((e) => console.log(e))
    },
    ...mapActions([
      'getDashboards'
    ]),

    checkedDefault (dashboard) {
      var newStatus = this.currentUser.currentDashboardId !== dashboard.id
      var defaultId = (this.currentDashboardId === parseInt(dashboard.id, 10) ? null : dashboard.id)
      this.$http.patch('/update_default_dashboard', { dashboard_id: dashboard.id, default: newStatus })
        .then(function(response){
          localStorage.token = response.data.jwt
          this.currentUser.defaultDashboardId = defaultId
        }.bind(this))
    }

  }
}
</script>

<style>
  .action-btn {
    font-size: 16px;
    border-radius: 30px;
    border-color: transparent !important;
    height: 35px;
    width: 35px;
    padding: 0;
    text-align: center;
  }
  .tab-content {
    background: transparent;
    border: none;
  }
  .tab-content .tab-pane {
    padding: 0;
  }
  .nav-tabs {
    border-bottom: 0px solid transparent;
    text-transform: uppercase;
    font-family: 'Cooper Hewitt Medium';
    letter-spacing: 2px;
  }
  .nav-tabs .nav-link:hover, .nav-tabs .nav-link.active, .nav-tabs .nav-link.active:focus {
    background: transparent;
    border-color: transparent;
  }
  .nav-tabs .nav-link:hover {
    color: #3493B2;
    border-bottom-color: transparent;
  }
  .nav-tabs .nav-link:after {
    content: "";
    display: block;
    width: calc(100% + 30px);
    margin-left: -15px;
    transform: translateY(8px);
    height: 3px;
    background-color: transparent;
    position: relative;
    -webkit-transition: all 0.3s ease;
		-moz-transition: all 0.3s ease;
		-o-transition: all 0.3s ease;
		transition: all .3s ease;
  }
  .nav-tabs .nav-link.active:after {
    content: "";
    display: block;
    width: calc(100% + 30px);
    margin-left: -15px;
    transform: translateY(8px);
    height: 3px;
    background-color: #58b2cd;
    position: relative;
    -webkit-transition: all 0.3s ease;
		-moz-transition: all 0.3s ease;
		-o-transition: all 0.3s ease;
		transition: all .3s ease;
 }
 .modal-body .nav-tabs {
    margin-bottom: 15px;
  }
</style>
